import imageCompression from "browser-image-compression";

export const imageCompressor = async (imageFile: File) => {

    console.log('originalFile instanceof Blob', imageFile instanceof Blob); // true
    console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`);

    const options = {
        maxSizeMB: 0.3,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
    }
    try {
        const compressedFile: File = await imageCompression(imageFile, options);
        console.log(compressedFile)
        return compressedFile
    } catch (error) {
        return null
    }
}
